module.exports = __webpack_public_path__ + "img/cn.37924662.png";